"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiXAPISet = exports.apiStudentXAPIGet = exports.apiTeacherXAPIGet = void 0;
const client_1 = require("./client");
const apiTeacherXAPIGet = async (courseId, after) => {
    const { data } = await client_1.default.get(`/courses/xapi-get-all/${courseId}`, {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiTeacherXAPIGet = apiTeacherXAPIGet;
const apiStudentXAPIGet = async (after) => {
    const { data } = await client_1.default.get('/courses/student/xapi-get-all', {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiStudentXAPIGet = apiStudentXAPIGet;
const apiXAPISet = async (taskId, value) => {
    await client_1.default.post('/courses/student/xapi-set', { taskId, value });
};
exports.apiXAPISet = apiXAPISet;
//# sourceMappingURL=xAPI.js.map